import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

/**
 * Componente de botón "Volver" reutilizable
 * @param {string} to - Ruta a la que navegar (opcional, por defecto va atrás en historial)
 * @param {object} sx - Estilos adicionales de MUI
 */
const BackButton = ({ to, sx = {} }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Tooltip title="Volver">
      <IconButton
        onClick={handleClick}
        sx={{
          bgcolor: 'rgba(26, 35, 126, 0.08)',
          color: '#1A237E',
          '&:hover': {
            bgcolor: 'rgba(26, 35, 126, 0.15)',
            transform: 'translateX(-4px)',
          },
          transition: 'all 0.3s ease',
          ...sx
        }}
      >
        <ArrowBackIcon />
      </IconButton>
    </Tooltip>
  );
};

export default BackButton;
